import type { ClusterStatus } from '@hp/domain';
import type { ClusterFilters } from './queries';

export const STATUSES = [
  'pending',
  'approved',
  'declined',
  'merged',
  'deleted',
] as const satisfies readonly ClusterStatus[];

export function parseFilters(sp: URLSearchParams): ClusterFilters {
  const entityType = sp.get('entityType');
  const tier = sp.get('tier');
  const status = sp.get('status');
  return {
    entityType: entityType === 'person' || entityType === 'organization' ? entityType : '',
    tier: tier === 'auto' || tier === 'review' ? tier : '',
    status: STATUSES.find((s) => s === status) ?? 'pending',
  };
}
